import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";


const StyledMiniatureContainer = styled.div`
    display: grid;
    gap: 40px;
    grid-template-columns: repeat(auto-fill, 400px);
    justify-content: center;
    margin-bottom: 40px;

    @media (max-width: 1000px) {
        grid-template-columns: repeat(auto-fill, 300px);
        gap: 20px;
    }
`;

const SeeMoreButton = styled.span`
    display: block;
    margin: 40px 0 40px;
    cursor: pointer;
    font-size: 50px;
    font-weight: 500;
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 5px;
    grid-column: 1 / -1;
`;

const MiniatureContainer = (props) => {

    const { i18n } = useTranslation('common');

    const [childrenToShow, setChildrenToShow] = useState(6);
    const totalChildrenCount = props.children.length;

    useEffect(() => {
        setChildrenToShow(6);
    }, [props.children]);

    return (
        <StyledMiniatureContainer>
            {props.children.slice(0, Math.min(childrenToShow,totalChildrenCount))}
            {childrenToShow < totalChildrenCount && <SeeMoreButton onClick={() => setChildrenToShow(childrenToShow + 50)}>{i18n.language === "fr" ? "Voir plus" : "See more"}</SeeMoreButton>}
        </StyledMiniatureContainer>
    );
}

export default MiniatureContainer;